<template>
  <div class="c-stars">
    <div class="star" :class="{'active': checkStar(count, 1), 'small': isSmall, 'normal': !isSmall, 'disabled': isDisabled}" @click="selectStar(1)" />
    <div class="star" :class="{'active': checkStar(count, 2), 'small': isSmall, 'normal': !isSmall, 'disabled': isDisabled}" @click="selectStar(2)" />
    <div class="star" :class="{'active': checkStar(count, 3), 'small': isSmall, 'normal': !isSmall, 'disabled': isDisabled}" @click="selectStar(3)" />
    <div class="star" :class="{'active': checkStar(count, 4), 'small': isSmall, 'normal': !isSmall, 'disabled': isDisabled}" @click="selectStar(4)" />
    <div class="star" :class="{'active': checkStar(count, 5), 'small': isSmall, 'normal': !isSmall, 'disabled': isDisabled}" @click="selectStar(5)" />
  </div>
</template>

<script>

export default {
  name: 'CStars',
  props: {
    isDisabled: {
      type: Boolean,
      default: true,
    },
    count: {
      type: Number,
      default: 0,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pressedCount: 0,
    }
  },
  watch: {},
  created() {
  },
  methods: {
    checkStar(count, starNum) {
      if (count !== 0) {
        return starNum <= count
      } else {
        if (this.pressedCount !== 0) {
          return starNum <= this.pressedCount
        } else {
          return false
        }
      }
    },
    selectStar(starNum) {
      this.pressedCount = starNum
      this.$emit('update:starCount', this.pressedCount)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-stars {
  display: flex;
  align-items: center;
  .star {
    cursor: pointer;
    position: relative;
    width: 15px;
    height: 15px;
    margin-right: 2px;
    &.normal {
      margin: 0 3px 25px 3px;

      &:before {
        content: ' \2605';
        position: absolute;
        font-size: 1.5em;
        color: #e3e2e2;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
      }
      &.active {
        &:before {
          content: ' \2605';
          position: absolute;
          font-size: 1.5em;
          color: var(--primary);
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
        }
      }
    }
    &.small {
      &:before {
        content: ' \2605';
        position: absolute;
        font-size: 1.2em;
        color: #e3e2e2;
        left: 0;
        right: 0;
        bottom: 0;
        top: -8.5px;
      }
      &.active {
        &:before {
          content: ' \2605';
          position: absolute;
          font-size: 1.2em;
          color: var(--primary);
          left: 0;
          right: 0;
          bottom: 0;
          top: -8.5px;
        }
      }
    }
    &.disabled {
     pointer-events: none;
    }
  }
}
</style>
